export const VISUAL_VIEWPORT_HEIGHT_VAR = '--visual-viewport-height'

const KEYBOARD_MIN_HEIGHT_PX = 120

export interface ViewportMetrics {
  layoutHeight: number
  visualHeight: number
}

export type SoftKeyboardViewport =
  | { keyboardOpen: false }
  | { keyboardOpen: true; heightPx: number }

export function resolveSoftKeyboardViewport({
  layoutHeight,
  visualHeight,
}: ViewportMetrics): SoftKeyboardViewport {
  if (layoutHeight - visualHeight < KEYBOARD_MIN_HEIGHT_PX) {
    return { keyboardOpen: false }
  }
  return { keyboardOpen: true, heightPx: Math.round(visualHeight) }
}

export function shouldResetScrollForSoftKeyboard(
  keyboardOpen: boolean,
  offsetTop: number,
  scrollY: number
): boolean {
  return keyboardOpen && (offsetTop > 0 || scrollY > 0)
}

export function applySoftKeyboardViewport(
  style: CSSStyleDeclaration,
  viewport: SoftKeyboardViewport
): void {
  if (!viewport.keyboardOpen) {
    style.removeProperty(VISUAL_VIEWPORT_HEIGHT_VAR)
    return
  }
  style.setProperty(VISUAL_VIEWPORT_HEIGHT_VAR, `${viewport.heightPx}px`)
}
